import $ from 'jquery';
import _ from 'underscore';
import { withLastPromise } from '@bingads-webui-universal/primitive-utilities';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { FeedAndAttributeSelectorView } from '@bingads-webui-campaign-react/feed-and-attribute-selector';
import { queryFeedsByName, cloneFeed, pickerCountdownInsert, keysForCountDown } from '../../service/utils/index';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/ad-customizers');

// todo: merge the picker logic with feedsEditor here

const COUNTDOWN_ID = -1;

/**
 * Feeds editor view
 */
class FeedsEditorView extends Backbone.View {
  initialize({
    target,
    options,
    remainingCountCallBack }) {

    this.target = target;
    this.showSyntax = true;
    this.remainingCountCallBack = remainingCountCallBack;
    this.fetchDataAndShow = withLastPromise({
      promiseFactory: queryFeedsByName,
      finish: (result) => {
        this.feeds = result;

        this.render();
      },
    });
    this.onSelectionUpdated(options);
  }

  onSelectionUpdated(options, remainingCountCallBack) {
    if (remainingCountCallBack) {
      this.remainingCountCallBack = remainingCountCallBack;
    }

    this.options = options || {};
    const { feed, attribute, feeds, specificFeedName, defaultText, isItemSelected, specificAttributeName } = options;

    if (this.specificFeedName === specificFeedName &&
      this.specificAttributeName === specificAttributeName &&
      this.selectedFeedName === feed &&
      this.selectedAttributeName === attribute &&
      this.defaultText === defaultText ) {
      return;
    }

    // whether user has specified feed name
    this.specificFeedName = specificFeedName;
    this.specificAttributeName = specificAttributeName;

    this.defaultText = defaultText;
    this.isItemSelected = isItemSelected;
    this.selectedFeedName = feed;
    this.selectedAttributeName = attribute;

    this.feeds = feeds || [];

    if (_.isEmpty(this.feeds)) {
      this.fetchDataAndShowToken = this.fetchDataAndShow(feed, this.el);
    } else {
      this.render();
    }
  }

  formatAdCustomizerFeed(prefix, suffix) {
    const escapeFeedName = (value) => {
      return value ? value.replace(/\./g, '\\.') : '';
    };
    const escapeAttrbuteName = (value) => {
      return value ? value.replace(/:/g, '\\:') : '';
    };

    const selectedAttributeNamePart = this.selectedAttributeName ? `.${escapeAttrbuteName(this.selectedAttributeName)}` : '';
    const defaultTextSelectedPart = this.defaultText && this.defaultText.length > 0 ? `:${this.defaultText.trim()}` : '';

    return `${prefix}{=${escapeFeedName(this.selectedFeedName)}${selectedAttributeNamePart}${defaultTextSelectedPart}}${suffix}`;
  }

  getSelectedFeed() {
    let feed = null;

    if (this.specificFeedName) {
      const feedName = this.selectedFeedName.toLowerCase();

      if (!_.isEmpty(this.feeds) && !_.isEmpty(feedName)) {
        // filter feeds by name
        const feeds = _.filter(this.feeds, (fe) => {
          return fe.Name.toLowerCase() === feedName;
        });

        if (!_.isEmpty(feeds)) {
          // generate a new feed, without interfering original data
          feed = cloneFeed(feeds[0]);
        }
        // update the feed attribute names based on user input
        // and make selectedAttribute name null when nothing matched
        if (feed && this.selectedAttributeName) {
          const attributeName = this.selectedAttributeName.toLowerCase();

          feed.AttributeNames = _.filter(feed.AttributeNames, (attribute) => {
            return attribute.toLowerCase().indexOf(attributeName) === 0;
          });

          if (!this.specificAttributeName &&
            ((_.isEmpty(feed.AttributeNames) ||
            feed.AttributeNames.length > 1 ||
            feed.AttributeNames[0].toLowerCase() !== attributeName))
          ) {
            this.selectedAttributeName = '';
          }
        }
      }
    }
    return feed;
  }

  updateTargetOnUserSelectionUpdate(userSelection, event) {
    let prefix = this.target.value.substring(0, this.options.startIndex);
    let endPart = this.target.value.substring(this.options.startIndex);
    let endPos = endPart.indexOf('}');
    let suffix = endPos > 0 ? endPart.substring(endPos + 1) : '';
    let newValue = '';
    let cursorPosition = 2;

    // when user select countdown
    if (userSelection.Id  === COUNTDOWN_ID) {
      newValue = `${prefix}${pickerCountdownInsert}${suffix}`;
      cursorPosition = this.options.startIndex + 2;
    } else {
      const { selectedFeedName, selectedAttributeName, defaultText } = userSelection;

      this.selectedFeedName = selectedFeedName;
      this.selectedAttributeName = selectedAttributeName;
      this.defaultText = defaultText;

      newValue = this.formatAdCustomizerFeed(prefix, suffix);
      cursorPosition = newValue.length - suffix.length;
    }

    this.options.updateAction(newValue);
    this.target.setSelectionRange(cursorPosition, cursorPosition);

    // when user select countdown, update target value, trigger ('click')
    //
    if (userSelection.Id === COUNTDOWN_ID) {
      // eslint-disable-next-line no-use-before-define
      hide();
      this.target.focus();
      $(this.target).trigger('click');

      // so that other events for the feedsEditor will be stopped (such as clickAway)
      event.stopPropagation();
      return false;
    }

    this.specificFeedName = true;

    // when there is no syntax perviously, we need to redraw the editor
    if (!this.showSyntax) {
      this.showSyntax = true;
      this.render();
      return true;
    }

    return true;
  }

  onFeedAttributeSelected(userSelection, event) {
    if (this.updateTargetOnUserSelectionUpdate(userSelection, event)) {
      this.target.focus();
      hide(); // eslint-disable-line no-use-before-define
    }
  }

  getFeedsToRender() {
    const shouldIncludeCountDownRule = !this.isItemSelected &&
      (!this.selectedFeedName || _.any(keysForCountDown, (ck) => {
        // after {=
        return ck.substring(2).indexOf(this.selectedFeedName.toLowerCase()) === 0;
      }));

    if (shouldIncludeCountDownRule) {
      this.feeds.unshift({
        Name: i18n.getString('Picker_Countdown_Label'),
        Description: i18n.getString('Picker_Countdown_Description'),
        Id: COUNTDOWN_ID,
      });
    }

    this.showSyntax = !shouldIncludeCountDownRule;

    return this.feeds;
  }

  render() {
    let $target = $(this.target);
    let position = $target.offset();

    position.top = position.top + $target.outerHeight();

    this.$el.css({
      position: 'absolute',
      visibility: 'visible',
      left: position.left,
      top: position.top,
    });

    // Clicking on elements having 'ac-helper-area' class won't hide currently visible helper
    this.$el.addClass('ac-helper-area adCustomizersEditor feeds-editor');
    const options = {
      feeds: this.getFeedsToRender(),
      selectedFeed: this.getSelectedFeed(),
      defaultText: this.defaultText,
      selectedAttribute: this.selectedAttributeName,
      showSyntax: this.showSyntax,
      onUserActionCompleted: (result, event) => {
        this.onFeedAttributeSelected(result, event);
      },
      onUserSelectionUpdated: (result, event) => {
        this.updateTargetOnUserSelectionUpdate(result, event);
      },
      i18n,
    };

    // total max length for default
    if (this.remainingCountCallBack) {
      options.maxLength = this.remainingCountCallBack() +
        (this.defaultText ? this.defaultText.length : 1);
    }

    ReactDOM.render(React.createElement(FeedAndAttributeSelectorView, options), this.el);
    return this;
  }

  remove() {
    if (this.fetchDataAndShowToken) {
      this.fetchDataAndShowToken.cancel();
      this.fetchDataAndShowToken = null;
    }

    return super.remove();
  }
}

/*
 * Editor instance (used by hide() and show() to update, register/deregister events and change visibility)
 */
let editor = null;

function clickedAway(event) {
  let target = $(event.target);

  if (target.closest('.ac-helper-area').length === 0 &&
    target.closest('.feed-and-attribute-selector').length === 0 &&
    target.closest('.feed-selector').length === 0 &&
    target.closest('.feed-attribute-selector').length === 0) {
    hide(); // eslint-disable-line no-use-before-define
  }
}

/**
 * Checks whether feeds editor is visible
 * @returns {bool} true if visible
 */
export function isVisible() {
  return editor !== null;
}

/**
 * Handles key down events.
 * Hides editor when user hits escape.
 * @param {object} event - click event
 * @returns {undefined}
 */
function keydown(event) {
  switch (event.key) {
  case 'Escape':
    hide(); // eslint-disable-line no-use-before-define
    break;
  default:
    break;
  }
}

/**
 * Hides feeds editor and deregisters clickaway event.
 * @returns {undefined}
 */
export function hide() {
  if (editor) {
    $(editor.target).off('keydown', keydown);
    $(window).off('click', clickedAway);
    editor.remove();
    editor = null;
  }
}

/**
 * Shows feeds editor and registers to global click events.
 * @param {object} target - element the editor will be attached to.
 * @param {object} options - editor model and cursor position info.
 * @param {function} remainingCountCallBack - callback function used to get the remainingcount
 * @returns {undefined}

 */
export function show(target, options, remainingCountCallBack) {
  // if already showing editor, update it
  if (isVisible()) {
    editor.onSelectionUpdated(options, remainingCountCallBack);
    return;
  }
  hide();

  editor = new FeedsEditorView({ target, options, remainingCountCallBack });

  $('body').append(editor.render().el);
  $(window).on('click', clickedAway);
  $(target).on('keydown', keydown);
}
